/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierBatchListItemDto
 */
export interface SupplierBatchListItemDto {
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListItemDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListItemDto
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchListItemDto
     */
    supplierName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchListItemDto
     */
    supplierPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchListItemDto
     */
    status: SupplierBatchListItemDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchListItemDto
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchListItemDto
     */
    periodEnd: Date;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchListItemDto
     */
    sentAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchListItemDto
     */
    respondedAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListItemDto
     */
    lineCount: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListItemDto
     */
    orderCount: number;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchListItemDto
     */
    createdAt: Date;
}


/**
 * @export
 */
export const SupplierBatchListItemDtoStatusEnum = {
    PendingReview: 'PENDING_REVIEW',
    SentToSupplier: 'SENT_TO_SUPPLIER',
    SupplierResponded: 'SUPPLIER_RESPONDED',
    ChangesPropagated: 'CHANGES_PROPAGATED',
    Completed: 'COMPLETED'
} as const;
export type SupplierBatchListItemDtoStatusEnum = typeof SupplierBatchListItemDtoStatusEnum[keyof typeof SupplierBatchListItemDtoStatusEnum];


/**
 * Check if a given object implements the SupplierBatchListItemDto interface.
 */
export function instanceOfSupplierBatchListItemDto(value: object): value is SupplierBatchListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('supplierId' in value) || value['supplierId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('supplierPhone' in value) || value['supplierPhone'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('sentAt' in value) || value['sentAt'] === undefined) return false;
    if (!('respondedAt' in value) || value['respondedAt'] === undefined) return false;
    if (!('lineCount' in value) || value['lineCount'] === undefined) return false;
    if (!('orderCount' in value) || value['orderCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function SupplierBatchListItemDtoFromJSON(json: any): SupplierBatchListItemDto {
    return SupplierBatchListItemDtoFromJSONTyped(json, false);
}

export function SupplierBatchListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierBatchListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'supplierId': json['supplierId'],
        'supplierName': json['supplierName'],
        'supplierPhone': json['supplierPhone'],
        'status': json['status'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'sentAt': (json['sentAt'] == null ? null : new Date(json['sentAt'])),
        'respondedAt': (json['respondedAt'] == null ? null : new Date(json['respondedAt'])),
        'lineCount': json['lineCount'],
        'orderCount': json['orderCount'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function SupplierBatchListItemDtoToJSON(value?: SupplierBatchListItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'supplierId': value['supplierId'],
        'supplierName': value['supplierName'],
        'supplierPhone': value['supplierPhone'],
        'status': value['status'],
        'periodStart': ((value['periodStart']).toISOString()),
        'periodEnd': ((value['periodEnd']).toISOString()),
        'sentAt': (value['sentAt'] == null ? null : (value['sentAt'] as any).toISOString()),
        'respondedAt': (value['respondedAt'] == null ? null : (value['respondedAt'] as any).toISOString()),
        'lineCount': value['lineCount'],
        'orderCount': value['orderCount'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

